module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t\t双录：\n\t\t")]), _vm._v("\n\t\t双录根据产品配置确定是否需要双录，若需要参照双录说明\n\t\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/contract0.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "01"
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t\t风险揭示书签署：\n\t\t")]), _vm._v("\n\t\t投资者需要对风险揭示书查看阅读并进行投资者声明确认，确认后进行签名、签章。\n\t\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/contract12.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/contract13.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/contact2.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "03"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t\t合同文件签署：\n\t\t")]), _vm._v("\n\t\t投资者签署完风险揭示可直接签署合同文件，查看阅读合同文件，并进行签字、签章。\n\t\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/contract11.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "01"
    }
  }, [_vm._v(_vm._s(_vm.message2))])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v(" 合同签署包含：双录、风险揭示书签署、合同文件签署\n\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-033ddf45"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/contractGuide.vue
// module id = 1010
// module chunks = 1